import React from 'react';
import { useLocation } from 'react-router-dom';

import Tippy from '@tippyjs/react';

import { COMPLETED_TRANSACTION_STATUSES } from 'lib/constants/transaction/completedTransactionStatuses';
import numOrDefault from 'lib/helpers/numOrDefault';
import { mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const AmountPaidSelf = ({ value, data }) => {
  const location = useLocation();
  const isFromBB = location?.pathname?.includes('/portal/beyond-billing');
  const isCompleted = COMPLETED_TRANSACTION_STATUSES.includes(data?.status);

  const baseAmount = numOrDefault(value);
  const surcharge = numOrDefault(data?.surcharge_amount);
  const refunded = numOrDefault(data?.amount_refunded);
  const refundedSurcharge = numOrDefault(data?.surcharge_refunded);
  const amountTotal = numOrDefault(data?.amount_total);

  let finalAmount = isFromBB ? baseAmount : baseAmount + refunded;
  if (!isCompleted) finalAmount = amountTotal;

  const isRefunded = refunded > 0 || refundedSurcharge > 0;
  const refundedDisplay = mString(refunded + refundedSurcharge);
  const chargeTooltip = mString(finalAmount - surcharge);
  const surchargeTooltip = mString(surcharge);

  return (
    <Tippy
      className="tippy-dark"
      content={
        <div className="flex flex-col gap-1">
          <Typography variant="span" size="small" color="white">
            Charge: <span>{chargeTooltip}</span>
          </Typography>
          <Typography variant="span" size="small" color="white">
            Technology fee: <span>{surchargeTooltip}</span>
          </Typography>
        </div>
      }>
      <div className="flex h-full items-center gap-1">
        <Typography variant="span" size="small" color="neutral-800">
          {mString(finalAmount)}
        </Typography>
        {isRefunded && (
          <Typography variant="span" size="small" color="neutral-800">
            (Refunded:<span className="font-bold">-{refundedDisplay}</span>)
          </Typography>
        )}
      </div>
    </Tippy>
  );
};

export default AmountPaidSelf;
